import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import styled from 'styled-components';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { ThemeProvider } from '@components/theme-provider';
import { Toaster } from '@components/toaster';
import { useIntercom } from '@hooks/use-intercom';

import { useCurrentUser } from 'api/authentication/hooks';
import { useEditMyDetails } from 'api/users/hooks';
import { getRoutePaths, RouteMapper } from 'ui/helpers';

import { routes } from './routes';

export const routePaths = getRoutePaths([{ routes }]);

export const PreboardingUserNavigation = () => {
  const currentUser = useCurrentUser();
  const { setUserData } = useIntercom();

  useEffect(() => {
    if (!currentUser) return;

    setUserData({
      id: `journeys-${currentUser.id}`,
      email: currentUser.email,
      name: currentUser.name,
      role: currentUser.role,
      picture: currentUser.picture,
      companyId: currentUser.company.id,
      companyName: currentUser.company.name,
    });
  }, [currentUser, setUserData]);

  return (
    <Container>
      <ThemeProvider app="journeys" theme={currentUser?.theme} updateTheme={useEditMyDetails}>
        <Routes>
          <Route path="*" element={<RouteConfig />} errorElement={<RouteErrorBoundary />} />
        </Routes>
        <Toaster />
      </ThemeProvider>
    </Container>
  );
};

const RouteConfig = () => {
  return <RouteMapper routes={routes} defaultRoute={routePaths.profilePic} />;
};

const Container = styled.div({
  display: 'flex',
});
